import React, { useState } from 'react';

import { APIcon } from '@components/atoms/APIcon';
import { Typography } from '@components/atoms/Typography';

export const CommonQuestionsSection: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    'AstroPayDownload.faq0',
    'AstroPayDownload.faq1',
    'AstroPayDownload.faq2',
    'AstroPayDownload.faq3',
  ];

  return (
    <section className="bg-gray-900 text-white w-full p-6 rounded-b-2xl mb-4 flex justify-center">
      <div className="w-full md:w-[560px]">
        <Typography
          textKey="AstroPayDownload.faqTitle"
          variant="h3"
          weight={600}
          className="text-md mb-3"
        />
        <ul className="text-sm divide-y divide-white divide-dashed">
          {faqs.map((faq, index) => (
            <li
              key={index}
              className="py-3 cursor-pointer text-left"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <Typography textKey={faq} variant="span" />
                <APIcon img={openIndex === index ? 'arrowUpWhite' : 'arrowDownWhite'} size={13} />
              </div>
              {openIndex === index && (
                <Typography
                  textKey={`AstroPayDownload.faqAnswer${index}`}
                  variant="p"
                  className="text-gray-100 mt-2"
                />
              )}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
